import type { Rule } from '../../../_types'

export const alertRulesObjectFromArray = (rulesArray: Rule[]) =>
  rulesArray.reduce(
    (a, b) => {
      a[b.key] = b

      return a
    },
    {} as { [key: string]: Rule },
  )
